import { supabase } from "../supabaseClient"
import { getValidSupabaseAccessToken } from "../utils/supabaseSession"

const FUNCTIONS_URL =
  process.env.REACT_APP_SUPABASE_FUNCTION_URL ||
  process.env.NEXT_PUBLIC_SUPABASE_FUNCTION_URL

export async function deleteOrganization(organizationId) {
  if (!organizationId) throw new Error("organizationId is required")
  if (!FUNCTIONS_URL) {
    throw new Error("Supabase function URL not configured")
  }

  const token = await getValidSupabaseAccessToken(supabase)
  if (!token) {
    throw new Error("Missing access token")
  }

  const response = await fetch(`${FUNCTIONS_URL}/delete-organization`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ organization_id: organizationId }),
  })

  const data = await response.json().catch(() => ({}))
  if (!response.ok) {
    const errorMessage = data?.error || "Failed to delete organization"
    throw new Error(errorMessage)
  }

  return data
}

export async function changeOrganizationType(organizationId, organizationType) {
  if (!organizationId) throw new Error("organizationId is required")
  if (!["automotive", "standard"].includes(organizationType)) {
    throw new Error("A valid organization type is required")
  }
  const { data, error } = await supabase.functions.invoke("set-organization-type", {
    body: { organization_id: organizationId, organization_type: organizationType },
  })
  if (error) throw error
  if (data?.error) throw new Error(data.error)
  return data
}
